'use client';

import KingSection6 from '@enlighten/landing/dist/king/@section6';
import { useState } from 'react';

import YouTubeDialog from '@/components/pages/exchange/YouTubeDialog';

export default function Section6() {
	const [src, setSrc] = useState<string>();

	return (
		<>
			<KingSection6
				onClick={(item) => {
					setSrc(item.src);
				}}
			/>
			<YouTubeDialog
				open={!!src}
				onClose={() => {
					setSrc(undefined);
				}}
				src={`https://www.youtube.com/embed/${src}?autoplay=1`}
			/>
		</>
	);
}
